import { MpLogger } from '@borg/logger';

export const logger = new MpLogger('BORG-WEB-APP');
